export const EVIDENCING_GROUP_OVERVIEW_TABLE = 'evidencing-group-overview-table'
export const ENROLLMENT_CONFIRMATION_SUPPLY_SHED_TABLE = 'enrollment-confirmation-supply-shed-table'

export const DEFAULT_TABLE_PREFERENCES = {
  headerConfig: {},
  expanded: true
}
